import React, { useMemo } from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import GitlabSecurityMappingForm, {
  GITLAB_SECURITY_SCAN_TYPE_OPTIONS,
} from "./GitlabSecurityMappingForm";
import GitlabSecurityCredentialsForm from "./GitlabSecurityCredentialsForm";
import { columnRenderArrayData } from "utils/tableUtils";

export default function GitlabSecurityConfigListing(props) {
  const columns = useMemo(
    () => [
      {
        title: "Project",
        dataIndex: "projectName",
        width: 240,
        render: columnRenderArrayData,
      },
      {
        title: "Scan Type",
        dataIndex: "scanType",
        width: 150,
        render: (scanType, record) => {
          const scanTypes = scanType
            ? scanType
                .split(",")
                .map((type) =>
                  Object.keys(GITLAB_SECURITY_SCAN_TYPE_OPTIONS).find(
                    (i) => GITLAB_SECURITY_SCAN_TYPE_OPTIONS[i] === type
                  )
                )
                .join()
            : "All";
          return columnRenderArrayData(scanTypes);
        },
      },
    ],
    []
  );
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={GitlabSecurityMappingForm}
      CredentialsForm={GitlabSecurityCredentialsForm}
      extraColumns={columns}
      displayComponentName={"Project"}
    />
  );
}
